import { render } from "./TeamForm.vue?vue&type=template&id=45c75c0c&scoped=true&ts=true"
import script from "./TeamForm.vue?vue&type=script&lang=ts"
export * from "./TeamForm.vue?vue&type=script&lang=ts"

import "./TeamForm.vue?vue&type=style&index=0&id=45c75c0c&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c75c0c"]])

export default __exports__